import React, { ChangeEvent } from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core';

import { RevisionContext } from '../RevisionContext';
import { HomeContext } from '../../../Home/HomeContext';
import { contentBatchModelInitial } from '../../../../Models/ContentBatchModel';
import { ContentModel, contentModelInitial } from '../../../../Models/ContentModel';
import ContentClientService from '../../../../Services/ContentClientService';
import { BasicConfirmDialog } from '../../../../shared/components/BasicConfirmDialog';
import { theme } from '../../../../theme';
import CategoryContentService from '../../../../Services/CategoryContentService';
import { BatchCorrectionContext } from '../BatchCorrectionContext';

export function ContentBatchCorrection() {

    const batchCorrectionContext = React.useContext(BatchCorrectionContext);
    const revisionContext = React.useContext(RevisionContext);
    const homeContext = React.useContext(HomeContext);

    const [contents, setContents] = React.useState<ContentModel[]>([]);
    const [contentSelected, setContentSelected] = React.useState<ContentModel | null>(null);

    const [contentError, setContentError] = React.useState(false);

    React.useEffect(() => {
        if (revisionContext.filterClassification.clientId != null && revisionContext.contentBatchOpenDialog) {
            ContentClientService.contentClientService(revisionContext.filterClassification.clientId)
                .getAll()
                .then((res: AxiosResponse) => { setContents(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    }, [revisionContext.contentBatchOpenDialog]);

    const hasError = () => {

        const errorContent: boolean = contents && contents.length > 0 && !contentSelected;

        setContentError(errorContent);

        return (errorContent);
    };

    const updateContentBatch = () => {
        if (!hasError()) {
            homeContext.setOpenLoadingDialog(true);

            const contentData = { ...contentBatchModelInitial };
            contentData.content = contentSelected ? contentSelected : contentModelInitial;
            contentData.categoriesId = revisionContext.ids;

            CategoryContentService.updateContentBatch(contentData)
                .then(() => {
                    clearModalContent();
                    batchCorrectionContext.setCallSearch(true);
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showSuccess(`As alterações foram realizadas para todas as ${revisionContext.ids.length} categorizações selecionadas com sucesso!`);
                })
                .catch((error: AxiosError) => {
                    homeContext.showError(' Ops... Ocorreu um erro e não foi possível salvar a alteração de teor. '
                        + 'Por favor, tente novamente dentro de alguns instantes. <br/>', error);
                    homeContext.setOpenLoadingDialog(false);
                });
        }
    };

    const clearModalContent = () => {
        revisionContext.setContentBatchOpenDialog(false);
        setContentSelected(null);
        setContentError(false);
    };

    const getContents = () => {
        return (
            <Grid container spacing={3}>
                {contents && contents.length > 0 &&
                    <Grid item xs={12}>
                        <FormControl component="fieldset" error={contentError}>
                            <FormLabel component="legend" error={false}>
                                <Typography variant="subtitle1">Teor</Typography>
                            </FormLabel>
                            <RadioGroup
                                row
                                value={contentSelected ? contentSelected.id.toString() : ''}
                                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                                    setContentSelected(contents.find(e => e.id == Number(event.target.value)) || null)}>
                                <Grid container spacing={3}>
                                    {contents.map(content =>
                                        <Grid item key={content.id}>
                                            <FormControlLabel
                                                value={content.id.toString()}
                                                control={<Radio color='primary' />}
                                                label={content.name} />
                                        </Grid>
                                    )}
                                </Grid>
                            </RadioGroup>
                            {contentError && !contentSelected && <FormHelperText>Selecione um teor</FormHelperText>}
                        </FormControl>
                    </Grid>
                }
            </Grid>
        );
    };

    return (
        <BasicConfirmDialog
            title={'Alteração de teor'}
            description={'Selecione o teor que deseja para as categorizações selecionadas.'}
            handleFirstButton={() => clearModalContent()}
            handleSecondButton={() => updateContentBatch()}
            textFirstButton='DESCARTAR'
            textSecondButton='SALVAR'
            open={revisionContext.contentBatchOpenDialog}
            children={getContents()}
            cssProperties={{
                minWidth: '800px',
                maxWidth: '1200px',
                padding: '1rem',
                colorFirstButton: theme.palette.primary.main,
                justifyButtons: 'flex-end',
                titleVariant: 'h4',
                descriptionVariant: 'body1'
            }} />
    );
}